if (!customElements.get('discount-products-scroll')) {
  class DiscountProductsScroll extends HTMLElement {
    constructor() {
      super();
      this.grid = this.querySelector('[data-discount-grid]');
      this.previousButton = this.querySelector('[data-discount-prev]');
      this.nextButton = this.querySelector('[data-discount-next]');
      this.status = this.querySelector('[data-discount-status]');
      this.loadingPromise = null;
    }

    connectedCallback() {
      if (!this.grid || !this.previousButton || !this.nextButton) return;

      this.previousButton.addEventListener('click', () => this.move(-1));
      this.nextButton.addEventListener('click', () => this.move(1));
      this.grid.addEventListener('scroll', () => this.handleScroll(), { passive: true });
      window.addEventListener('resize', () => this.updateControls());
      requestAnimationFrame(() => this.updateControls());
    }

    async move(direction) {
      if (direction > 0 && this.nearEnd() && this.dataset.nextPage) {
        await this.loadNextDiscounts();
      }

      this.grid.scrollBy({
        left: direction * Math.max(this.grid.clientWidth * 0.78, 280),
        behavior: 'smooth'
      });
    }

    handleScroll() {
      this.updateControls();
      if (this.nearEnd() && this.dataset.nextPage) this.loadNextDiscounts();
    }

    nearEnd() {
      return this.grid.scrollLeft + this.grid.clientWidth >= this.grid.scrollWidth - 160;
    }

    updateControls() {
      const maxScroll = this.grid.scrollWidth - this.grid.clientWidth;
      this.previousButton.disabled = this.grid.scrollLeft <= 2;
      this.nextButton.disabled = maxScroll <= 2 || (!this.dataset.nextPage && this.grid.scrollLeft >= maxScroll - 2);
    }

    async loadNextDiscounts() {
      if (this.loadingPromise || !this.dataset.nextPage) return this.loadingPromise;

      this.setAttribute('loading', '');
      this.loadingPromise = this.fetchNextPages();

      try {
        await this.loadingPromise;
      } finally {
        this.loadingPromise = null;
        this.removeAttribute('loading');
        this.updateControls();
      }
    }

    async fetchNextPages() {
      while (this.dataset.nextPage) {
        const nextPage = this.dataset.nextPage;
        const url = new URL(window.location.href);
        url.searchParams.set('section_id', this.dataset.sectionId);
        url.searchParams.set('page', nextPage);

        const response = await fetch(url.toString(), {
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });
        if (!response.ok) throw new Error(`Request failed: ${response.status}`);

        const html = await response.text();
        const documentFragment = new DOMParser().parseFromString(html, 'text/html');
        const nextSection = documentFragment.querySelector('discount-products-scroll');
        if (!nextSection) {
          this.dataset.nextPage = '';
          return;
        }

        const nextGrid = nextSection.querySelector('[data-discount-grid]');
        const products = nextGrid ? Array.from(nextGrid.children) : [];
        this.dataset.currentPage = nextPage;
        this.dataset.nextPage = nextSection.dataset.nextPage || '';

        if (products.length > 0) {
          const fragment = document.createDocumentFragment();
          products.forEach((product) => fragment.appendChild(product));
          this.grid.appendChild(fragment);
          if (this.status) this.status.textContent = `${products.length} more discount products loaded.`;
          if (window.StampedFn && typeof window.StampedFn.loadBadges === 'function') window.StampedFn.loadBadges();
          return;
        }
      }
    }
  }

  customElements.define('discount-products-scroll', DiscountProductsScroll);
}
